import axios from "axios"
import moment from 'moment-timezone' // สำหรับ set timezone https://momentjs.com/timezone/docs/
import 'moment/locale/th' //  สำหรับ display เดือนเป็นภาษาไทย (optional)
// import store from "../stores/store";
const general = {
  async getSysDate() {
    const diffTime = localStorage.getItem("system-date:diff-time")
    const serverDateTime = new Date(Date.now() + (diffTime != null ? Number(diffTime) : 0))
    const getTimezone = localStorage.getItem("system-date:timezone") || Intl.DateTimeFormat().resolvedOptions().timeZone

    let sysDate = moment.tz(serverDateTime, getTimezone)

    sysDate = moment(sysDate).format("YYYYMMDD")
    sysDate = Number(sysDate.substring(0, 4)) + 543 + sysDate.substring(4)

    return Promise.resolve(sysDate)
  },
  formatYYMM(data) {
    if (!data) return "";
    data = data.toString()
    let [month, year] = [
      data.substring(2, 4),
      data.substring(0, 2),
    ];
    if (Number(month) == 0) {
      month = "-";
    } else if (Number(month) <= 12) {
      month = general.getThaiMonth(parseInt(month)).desc;
    }
    return `${month} 25${year}`;
  },
  formatDateToDisplay(date) {
    if (date == 0) return ""
    if (date == "-") return "-"
    let data = date.toString().padEnd(8, "0")
    let [year, month, day] = [
      data.substring(0, 4),
      data.substring(4, 6),
      data.substring(6)
    ]
    if (Number(month) == 0) {
      month = "-"
    } else if (Number(month) <= 12) {
      month = this.getThaiMonth(parseInt(month)).desc
    }
    if (Number(day) == 0) {
      day = "-"
    } else {
      day = parseInt(day)
    }
    return `${day} ${month} พ.ศ. ${year}`
  },
  getThaiMonth(month) {
    let thaiMonths = [{
      "code": 0,
      "desc": ""
    }, {
      "code": 1,
      "desc": "มกราคม"
    }, {
      "code": 2,
      "desc": "กุมภาพันธ์"
    }, {
      "code": 3,
      "desc": "มีนาคม"
    }, {
      "code": 4,
      "desc": "เมษายน"
    }, {
      "code": 5,
      "desc": "พฤษภาคม"
    }, {
      "code": 6,
      "desc": "มิถุนายน"
    }, {
      "code": 7,
      "desc": "กรกฎาคม"
    }, {
      "code": 8,
      "desc": "สิงหาคม"
    }, {
      "code": 9,
      "desc": "กันยายน"
    }, {
      "code": 10,
      "desc": "ตุลาคม"
    }, {
      "code": 11,
      "desc": "พฤศจิกายน"
    }, {
      "code": 12,
      "desc": "ธันวาคม"
    }, ]
    return thaiMonths[month]
  },
  getListsCC() {
    let jsonCC = [{
      "code": "10",
      "desc": "กรุงเทพมหานคร"
    }, {
      "code": "11",
      "desc": "สมุทรปราการ"
    }, {
      "code": "12",
      "desc": "นนทบุรี"
    }, {
      "code": "13",
      "desc": "ปทุมธานี"
    }, {
      "code": "14",
      "desc": "พระนครศรีอยุธยา"
    }, {
      "code": "15",
      "desc": "อ่างทอง"
    }, {
      "code": "16",
      "desc": "ลพบุรี"
    }, {
      "code": "17",
      "desc": "สิงห์บุรี"
    }, {
      "code": "18",
      "desc": "ชัยนาท"
    }, {
      "code": "19",
      "desc": "สระบุรี"
    }, {
      "code": "20",
      "desc": "ชลบุรี"
    }, {
      "code": "21",
      "desc": "ระยอง"
    }, {
      "code": "22",
      "desc": "จันทบุรี"
    }, {
      "code": "23",
      "desc": "ตราด"
    }, {
      "code": "24",
      "desc": "ฉะเชิงเทรา"
    }, {
      "code": "25",
      "desc": "ปราจีนบุรี"
    }, {
      "code": "26",
      "desc": "นครนายก"
    }, {
      "code": "27",
      "desc": "สระแก้ว"
    }, {
      "code": "30",
      "desc": "นครราชสีมา"
    }, {
      "code": "31",
      "desc": "บุรีรัมย์"
    }, {
      "code": "32",
      "desc": "สุรินทร์"
    }, {
      "code": "33",
      "desc": "ศรีสะเกษ"
    }, {
      "code": "34",
      "desc": "อุบลราชธานี"
    }, {
      "code": "35",
      "desc": "ยโสธร"
    }, {
      "code": "36",
      "desc": "ชัยภูมิ"
    }, {
      "code": "37",
      "desc": "อำนาจเจริญ"
    }, {
      "code": "38",
      "desc": "บึงกาฬ"
    }, {
      "code": "39",
      "desc": "หนองบัวลำภู"
    }, {
      "code": "40",
      "desc": "ขอนแก่น"
    }, {
      "code": "41",
      "desc": "อุดรธานี"
    }, {
      "code": "42",
      "desc": "เลย"
    }, {
      "code": "43",
      "desc": "หนองคาย"
    }, {
      "code": "44",
      "desc": "มหาสารคาม"
    }, {
      "code": "45",
      "desc": "ร้อยเอ็ด"
    }, {
      "code": "46",
      "desc": "กาฬสินธุ์"
    }, {
      "code": "47",
      "desc": "สกลนคร"
    }, {
      "code": "48",
      "desc": "นครพนม"
    }, {
      "code": "49",
      "desc": "มุกดาหาร"
    }, {
      "code": "50",
      "desc": "เชียงใหม่"
    }, {
      "code": "51",
      "desc": "ลำพูน"
    }, {
      "code": "52",
      "desc": "ลำปาง"
    }, {
      "code": "53",
      "desc": "อุตรดิตถ์"
    }, {
      "code": "54",
      "desc": "แพร่"
    }, {
      "code": "55",
      "desc": "น่าน"
    }, {
      "code": "56",
      "desc": "พะเยา"
    }, {
      "code": "57",
      "desc": "เชียงราย"
    }, {
      "code": "58",
      "desc": "แม่ฮ่องสอน"
    }, {
      "code": "60",
      "desc": "นครสวรรค์"
    }, {
      "code": "61",
      "desc": "อุทัยธานี"
    }, {
      "code": "62",
      "desc": "กำแพงเพชร"
    }, {
      "code": "63",
      "desc": "ตาก"
    }, {
      "code": "64",
      "desc": "สุโขทัย"
    }, {
      "code": "65",
      "desc": "พิษณุโลก"
    }, {
      "code": "66",
      "desc": "พิจิตร"
    }, {
      "code": "67",
      "desc": "เพชรบูรณ์"
    }, {
      "code": "70",
      "desc": "ราชบุรี"
    }, {
      "code": "71",
      "desc": "กาญจนบุรี"
    }, {
      "code": "72",
      "desc": "สุพรรณบุรี"
    }, {
      "code": "73",
      "desc": "นครปฐม"
    }, {
      "code": "74",
      "desc": "สมุทรสาคร"
    }, {
      "code": "75",
      "desc": "สมุทรสงคราม"
    }, {
      "code": "76",
      "desc": "เพชรบุรี"
    }, {
      "code": "77",
      "desc": "ประจวบคีรีขันธ์"
    }, {
      "code": "80",
      "desc": "นครศรีธรรมราช"
    }, {
      "code": "81",
      "desc": "กระบี่"
    }, {
      "code": "82",
      "desc": "พังงา"
    }, {
      "code": "83",
      "desc": "ภูเก็ต"
    }, {
      "code": "84",
      "desc": "สุราษฎร์ธานี"
    }, {
      "code": "85",
      "desc": "ระนอง"
    }, {
      "code": "86",
      "desc": "ชุมพร"
    }, {
      "code": "90",
      "desc": "สงขลา"
    }, {
      "code": "91",
      "desc": "สตูล"
    }, {
      "code": "92",
      "desc": "ตรัง"
    }, {
      "code": "93",
      "desc": "พัทลุง"
    }, {
      "code": "94",
      "desc": "ปัตตานี"
    }, {
      "code": "95",
      "desc": "ยะลา"
    }, {
      "code": "96",
      "desc": "นราธิวาส"
    }]
    for (let json in jsonCC) {
      let item = jsonCC[json];
      let descWithCode = {
        descWithCode: item.code + " : " + item.desc
      }
      jsonCC[json] = Object.assign(descWithCode, item)
    }
    return jsonCC
  },
  //stat
  getRcodeStat(cc) {
    let pathApi = "../../connectSAPI/stat_forward.php?API=";
    let apiPath = '/api/stat/statcenter/v1/list?action=2&cc=' + cc
    if (window.location.hostname != "localhost") {
      apiPath = pathApi + apiPath
    }
    return new Promise((resolve, reject) => {
      axios.get(apiPath, {})
        .then(function (response) {
          let listsRcode = response.data
          for (let json in listsRcode) {
            let item = listsRcode[json];
            let descWithCode
            if (item.lsrcodedesc.substring(0, 8) == "ท้องถิ่น") {
              descWithCode = {
                descWithCode: item.lsrcodecode + " : " + item.lsrcodedesc
              }
            } else {
              descWithCode = {
                descWithCode: item.lsrcodecode + " : " + item.lsrcodedesc
              }
            }
            let code = {
              code: item.lsrcodecode.toString()
            }
            let desc = {
              desc: item.lsrcodedesc
            }
            listsRcode[json] = Object.assign(descWithCode, code, desc, item)
          }
          resolve(listsRcode)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  async getCodeAA(rcode,yymm) {
    let pathApi = "../../connectSAPI/stat_forward.php?API=";
    let apiPath = '/api/stat/statcenter/v1/list?action=614&rcode=' + rcode + '&yymm=' + yymm
    if (window.location.hostname != "localhost") {
      apiPath = pathApi + apiPath
    }
      let aacode = await axios.get(apiPath, { 

      })
      return Promise.resolve(aacode.data[0].aaCode)
  },
  async getCodeAumphur(rcode,yymm) {
    let pathApi = "../../connectSAPI/stat_forward.php?API=";
    let apiPath = '/api/stat/statcenter/v1/list?action=614&rcode=' + rcode + '&yymm=' + yymm
    if (window.location.hostname != "localhost") {
      apiPath = pathApi + apiPath
    }
      let aacode = await axios.get(apiPath, { 

      })
      return Promise.resolve(aacode.data)
  },
  async getSubRcodeStat(rcode,aa,yymm) {
    let pathApi = "../../connectSAPI/stat_forward.php?API=";
    let apiPath = '/api/stat/statcenter/v1/list?action=616&rcode=' + rcode + '&aa=' + aa + '&yymm=' + yymm
    if (window.location.hostname != "localhost") {
      apiPath = pathApi + apiPath
    }
    return new Promise((resolve, reject) => {
      axios.get(apiPath, {})
        .then(function (response) {
          let listsSubRcode = response.data
          for (let json in listsSubRcode) {
            let item = listsSubRcode[json];
            let descWithCode = {
              descWithCode: item.lscatmTTcode.toString().substring(0, 6) + " : " + item.lscatmTTdesc
            }
            let code = {
              code: item.lscatmTTcode.toString()
            }
            let desc = {
              desc: item.lscatmTTdesc
            }
            listsSubRcode[json] = Object.assign(descWithCode, code, desc, item)

          }
          resolve(listsSubRcode)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  async getMooStat(rcode, aa, yymm, tt) {
    let getAAcode = await this.getCodeAA(rcode,yymm)
    let pathApi = "../../connectSAPI/stat_forward.php?API=";
    let apiPath = '/api/stat/statcenter/v1/list?action=617&rcode=' + rcode + '&aa=' + getAAcode + '&yymm=' + yymm + '&tt=' + tt
    if (window.location.hostname != "localhost") {
      apiPath = pathApi + apiPath
    }
    return new Promise((resolve, reject) => {
      axios.get(apiPath, {})
        .then(function (response) {
          let listsSubRcode = response.data
          for (let json in listsSubRcode) {
            let item = listsSubRcode[json];
            let descWithCode = {
              descWithCode: item.lscatmMMcode + " : " + item.lscatmMMdesc
            }
            let code = {
              code: item.lscatmMMcode.toString()
            }
            let desc = {
              desc: item.lscatmMMdesc
            }
            listsSubRcode[json] = Object.assign(descWithCode, code, desc, item)
          }
          resolve(listsSubRcode)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

}

export default general